module.exports = __webpack_public_path__ + "img/activethreedots.cdfda4e6.svg";